import { IoLogoCss3 } from 'react-icons/io'

export const CSSTech = () => {
    return (
        <div>
        <IoLogoCss3 />
        <h4>CSS 3</h4>
        </div>
    )
}